export const LimitOperationTypes = {
  PIX: 40,
  TED: 3
}

export const LimitTypes = {
  DAILY: 0,
  OVERNIGHT: 3,
  TRANSACTION: 4,
  TITULAR: 5
}

export const LimitRequestJustifications = {
  BUSINESS: 0,
  INCOME: 1,
  EMERGENCY: 2,
  EDUCATION: 3,
  HEALTH: 4,
  TRAVEL: 5,
  RENOVATION: 6
}